import React from "react";

export default function FormStickyFooter({
  onBack,
  onPrimary,
  primaryLabel = "Continue",
  primaryDisabled = false,
  primaryLoading = false,
  backLabel = "Back",
  showBack = true,
}) {
  return (
    <div className="sticky bottom-0 z-20 -mx-4 px-4 py-3 mt-6 border-t border-slate-200 bg-white/95 backdrop-blur-sm md:-mx-6 md:px-6">
      <div className="flex items-center justify-between gap-3">
        {showBack ? (
          <button
            type="button"
            onClick={onBack}
            className="px-4 py-2.5 rounded-xl bg-slate-200 hover:bg-slate-300 text-sm font-medium"
          >
            {backLabel}
          </button>
        ) : (
          <span />
        )}
        <button
          type="button"
          onClick={onPrimary}
          disabled={primaryDisabled || primaryLoading}
          className={`px-6 py-2.5 rounded-xl text-sm font-medium text-white ${
            primaryDisabled || primaryLoading
              ? "bg-sky-300 cursor-not-allowed"
              : "bg-sky-600 hover:bg-sky-700"
          }`}
        >
          {primaryLoading ? "Please wait…" : primaryLabel}
        </button>
      </div>
    </div>
  );
}
